export default __webpack_public_path__ + "static/media/DHTable2Img.ac79e181.PNG";